var _foreignObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 73h204v204H73z",
    style: {
      fill: "#a54225"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m300.833 86.319-17.656-8.209 45.625-60.631-89.951 69.172-23.768-11.985 11.77 21.211-56.798 43.678-35.764-72.639h-6.583l12.792 75.417-45.799-16.087-12.472-27.913-3.745 22.217L17.25 99.042l79.941 65.467-11.247 17.602 21.327-9.347 19.062 15.611-26.632 37.558-22.313 6.428 14.492 4.601-49.979 70.483 97.224-71.284 6.208 13.117 2.799-19.721 15.27-11.196 58.069 95.5-20.806-98.944 81.24 22.865-41.812-35.506 12.572-6.816-23.268-2.267-20.024-17.004 18.458-24.529 14.722 10.397-7.531-19.954 38.83-51.602z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m134.325 80.678 12.716 63.988 11 3.833 4.917-3.5zm-97.769 28.961 63.944 49.5 2.611-3.972 4.139 2.805-8.194 12.972 12.611-5.555 1.333 3.25 20.667 16.028 24.333.555-3.875-29.389L84.431 128.5l5.791-.111-5.93-13.097-2.098 13.555-5.027-.889.541-2.194zm123.222 48.083 67.606-52.618a46.3 46.3 0 0 1 7.811-5.132l-.639-.417 59.083-46.25-16.806 22.056-3.444-1.667-1.944 4.361L283.854 84l-14.229 2.208.833-2.646-38.556 50.396-.208-.472-4.917 2.111 5 12.875-12.528-9.201-3 4.042 5.562 4.021-31.396 40.806-30.427-2.649q-.104-13.885-.21-27.769m67.66-71.18 6.979 12.291 4.75-6.333zm-23.188 96.875-9.917 12.667 2.167 9.611 58.861 18.111-22.528-17.833-9.667 5.222-2.444-4.444 14.889-7.972-13.653-1.257q-8.853-7.054-17.708-14.105m-16.542 17.25 21.896 83.687-38.493-71.382zm-28.569-14.361 25.083 7.361-34.514 26.188-4.667-1.208-2.229 13.562-6.458-13.938-4.708 2.104 4.562 9.583-70.968 53.521 33.524-44.465 7.292 2.389 1.333-4.736-12.806-4 14.667-4.333a8 8 0 0 0 .542-3.833l25.361-33.528z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesion);
export default __webpack_public_path__ + "static/media/lesion.2b0e6a19070bd81954d91b8e597f058f.svg";
export { ForwardRef as ReactComponent };